export const AppoinitmentType = {
  BOOK_APPOINTMENT_REQUEST: "BOOK_APPOINTMENT_REQUEST",
  CONFIRM_APPOINTMENT_REQUEST: "CONFIRM_APPOINTMENT_REQUEST",
  UPDATE_APPOINTMENT_REQUEST: "UPDATE_APPOINTMENT_REQUEST",
  BLOCK_APPOINTMENT_REQUEST: "BLOCK_APPOINTMENT_REQUEST",
  CANCEL_APPOINTMENT_REQUEST: "CANCEL_APPOINTMENT_REQUEST",
  RESCHEDULE_APPOINTMENT_REQUEST: "RESCHEDULE_APPOINTMENT_REQUEST",
  GET_ALL_APPOINTMENT_SUCCESS: "GET_ALL_APPOINTMENT_SUCCESS",
  GET_ALL_APPOINTMENT_REQUEST: "GET_ALL_APPOINTMENT_REQUEST",
  GET_ALL_TODAY_APPOINTMENT_REQUEST: "GET_ALL_TODAY_APPOINTMENT_REQUEST",
  GET_ALL_PAST_APPOINTMENT_REQUEST: "GET_ALL_PAST_APPOINTMENT_REQUEST",
  GET_ALL_FUTRUE_APPOINTMENT_REQUEST: "GET_ALL_FUTRUE_APPOINTMENT_REQUEST",
  GET_ALL_TOMORROW_APPOINTMENT_REQUEST: "GET_ALL_TOMORROW_APPOINTMENT_REQUEST",
  GET_ALL_WEEKLY_APPOINTMENT_REQUEST: "GET_ALL_WEEKLY_APPOINTMENT_REQUEST",
  GET_APPOINTMENT_BY_ID_REQUEST: "GET_APPOINTMENT_BY_ID_REQUEST",
  CLEAR_ALL_STATE: "CLEAR_ALL_STATE",
  APPOINTMENT_COMMON_SUCCESS: "APPOINTMENT_COMMON_SUCCESS",
  APPOINTMENT_COMMON_FAILIURE: "APPOINTMENT_COMMON_FAILIURE",
  UPDATE_APPOINTMENT_SUCCESS: "UPDATE_APPOINTMENT_SUCCESS",
  GET_ALL_APPOINTMENT_SUCCESS: "GET_ALL_APPOINTMENT_SUCCESS",
  GET_APPOINTMENT_BY_ID_SUCCESS: "GET_APPOINTMENT_BY_ID_SUCCESS",
  ERROR_IN_APPOINTMENT_REQUEST : "ERROR_IN_APPOINTMENT_REQUEST",
  CHECK_IN_PATIENT_REQUEST : "CHECK_IN_PATIENT_REQUEST"
};
